import { Target } from 'lucide-react';
import { useAnalysisContext } from '../../contexts/AnalysisContext';
import { getGrade } from '../../lib/grades';

export function AnalysisHero({ swingHistory }) {
  const {
    analysisResult,
    setShowFullAnalysis,
    resetAnalysis,
  } = useAnalysisContext();

  if (!analysisResult) return null;

  const score = analysisResult.swingScore?.overall || 0;
  const grade = getGrade(score);
  const handicapRange = analysisResult.projectedHandicap?.range || null;
  const topIssue = analysisResult.whatsCostingStrokes?.[0]?.issue || null;

  return (
    <div className="max-w-2xl mx-auto">
      {/* Score + Handicap */}
      <div className="text-center">
        <p className="text-slate-400 text-sm mb-2">Your SwingScore</p>
        <div className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold bg-gradient-to-r from-emerald-400 to-green-400 bg-clip-text text-transparent mb-1">
          {score}
        </div>
        <p className="text-xl font-bold text-white mb-2">{grade}</p>

        {handicapRange && (
          <p className="text-slate-400 mb-2">
            Projected Handicap: <span className="text-white font-bold">{handicapRange}</span>
          </p>
        )}

        <div className="w-40 sm:w-48 md:w-64 h-3 bg-white/10 rounded-full mx-auto mb-4">
          <div
            className="h-full bg-gradient-to-r from-emerald-500 to-green-500 rounded-full transition-all duration-1000"
            style={{ width: `${score}%` }}
          />
        </div>

        {/* Progress from last swing */}
        {swingHistory.length > 1 && swingHistory[1]?.swingScore && (() => {
          const prevScore = typeof swingHistory[1].swingScore === 'object'
            ? swingHistory[1].swingScore.overall
            : swingHistory[1].swingScore;
          if (!prevScore) return null;
          const scoreDiff = score - prevScore;
          let changeText, changeColor;

          if (scoreDiff > 0) {
            changeText = `+${scoreDiff} points from last time`;
            changeColor = 'text-emerald-400';
          } else if (scoreDiff >= -5) {
            changeText = 'Similar to last time';
            changeColor = 'text-slate-400';
          } else {
            changeText = 'New focus areas identified';
            changeColor = 'text-amber-400';
          }

          return (
            <div className={`text-lg font-bold mb-4 ${changeColor}`}>
              {changeText}
            </div>
          );
        })()}
      </div>

      {/* Top Issue */}
      {topIssue && (
        <div className="rounded-2xl bg-white/5 p-6 border border-white/10 mb-6 text-center">
          <div className="flex items-center justify-center gap-2 text-amber-400 text-sm font-medium mb-3">
            <Target className="h-4 w-4" />
            #1 ISSUE
          </div>
          <p className="text-xl text-white font-medium mb-6">"{topIssue}"</p>
          <button
            onClick={() => setShowFullAnalysis(true)}
            className="w-full rounded-xl bg-gradient-to-r from-emerald-500 to-green-500 px-6 py-4 font-bold text-black hover:scale-105 transition"
          >
            See Full Analysis
          </button>
        </div>
      )}

      {!topIssue && (
        <button
          onClick={() => setShowFullAnalysis(true)}
          className="w-full text-slate-400 hover:text-white text-sm py-2 transition mb-1"
        >
          See Full Analysis
        </button>
      )}

      <button
        onClick={resetAnalysis}
        className="w-full text-slate-400 hover:text-white text-sm py-2 transition"
      >
        New Lesson
      </button>
    </div>
  );
}
